// extracted by mini-css-extract-plugin
export default {"cardMedia":"W0-z","shopText":"X0-z","videoPlayer":"Y0-z","videoContainer":"Z0-z"};